var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPangaiaBeeTrail(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 125 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125 2c-13.01 9.006-29.04 17.943-38.289 32.287-7.017 10.883-9.567 20.657-12.113 33.721-.789 4.046-3.04 13.348 1.217 15.857 6.03 3.553 16.03-.219 21.001-4.377 12.175-10.184.218-20.791-9.679-22.529-18.38-3.227-36.097 10.14-51.132 20.807C20.97 88.433 2 106 2 106",
    stroke: "#000",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 10"
  })));
}

export default SvgPangaiaBeeTrail;